import { CustomRequestOptions } from '@/interceptors/request'
import { showModal, getEnvBaseUrl } from '@/utils/index'
import i18n from '@/locale/index'
import { useUserStore } from '@/store/user'
import { getStorage } from '@/utils/storage'
import { useLoginStore } from '@/store/modules/login'

const t = i18n.global.t

// const baseUrl = getEnvBaseUrl()

/**
 * 请求方法: 主要是对 uni.request 的封装，去适配 openapi-ts-request 的 request 方法
 * @param options 请求参数
 * @returns 返回 Promise 对象
 */
const http = <T>(options: CustomRequestOptions) => {
  // 默认显示loading，除非明确指定不显示
  const showLoading = options.showLoading !== false
  // console.log('showLoading', showLoading)
  // 显示loading
  if (showLoading) {
    ;(uni as any).$loading?.show({
      title: options.loadingText || t('request.loading'),
    })
  }
  // options.url = baseUrl + options.url

  // 1. 返回 Promise 对象
  return new Promise<T>((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.statusCode >= 200 && res.statusCode < 300) {
          // 2.1 提取核心数据 res.data
          resolve(res.data as T)
        } else if (res.statusCode === 401) {
          const userStore = useUserStore()
          const tg = getStorage('tg')
          if (Object.keys(tg.initDataUnsafe).length > 0) {
            console.log('tg 登录1232131')
            return new Promise((resolve, reject) => {
              userStore
                .tgLogin()
                .then((res) => {
                  if (res.code === 0) {
                    // TG 登录成功后，重新发起原始请求
                    uni.request({
                      ...options,
                      success: (response) => {
                        options.success?.(response)
                        resolve(response)
                      },
                      fail: (error) => {
                        options.fail?.(error)
                        reject(error)
                      },
                    })
                  } else {
                    const error = {
                      errMsg: res.msg || '登录失败',
                    }
                    options.fail?.(error)
                    reject(error)
                  }
                })
                .catch((error) => {
                  const failResult = {
                    errMsg: error?.message || '登录失败',
                  }
                  options.fail?.(failResult)
                  reject(failResult)
                })
            })
          }
          // 401错误  -> 清理用户信息，跳转到登录页
          // userStore.clearUserInfo()
          // uni.navigateTo({ url: '/pages/login/login' })
          userStore.clearUserInfo()
          const loginStore = useLoginStore()
          loginStore.showLogin()
          reject(res)
        } else {
          // 其他错误 -> 根据后端错误信息轻提示
          !options.hideErrorToast &&
            showModal((res.data as T & { msg?: string })?.msg || t('request.requestError'), {
              showCancel: false,
            })
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        uni.showToast({
          icon: 'none',
          title: t('request.networkError'),
        })
        reject(err)
      },
      // 请求完成
      complete() {
        // 隐藏loading
        if (showLoading) {
          // uni.hideLoading()
          ;(uni as any).$loading?.hide()
        }
      },
    })
  })
}

/*
 * openapi-ts-request 工具的 request 跨客户端适配方法
 */
export default function request<T = unknown>(
  url: string,
  options: Omit<CustomRequestOptions, 'url'> & {
    params?: Record<string, unknown>
    headers?: Record<string, unknown>
    showLoading?: boolean // 是否显示loading
    loadingText?: string // loading提示文本
  },
) {
  const requestOptions = {
    url,
    ...options,
  }

  if (options.params) {
    requestOptions.query = requestOptions.params
    delete requestOptions.params
  }

  if (options.headers) {
    requestOptions.header = options.headers
    delete requestOptions.headers
  }

  return http<T>(requestOptions)
}
